/* unplugin-vue-components disabled */import script from "./RoleCardResumes.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCardResumes.vue?vue&type=script&setup=true&lang=js"

import "./RoleCardResumes.vue?vue&type=style&index=0&id=4dfd29fc&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfd29fc"]])

export default __exports__